import { faLink } from '@fortawesome/free-solid-svg-icons/faLink';
import { faPlusCircle } from '@fortawesome/free-solid-svg-icons/faPlusCircle';
import React, { useEffect } from 'react';
import { Trans, useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';

import { AtiraEmptyWithAction } from '../../../components/AtiraEmptyWithAction';
import { Flex } from '../../../components/Flex';
import { Text } from '../../../components/Text';
import { useAppDispatch, useAppSelector } from '../../../redux/store';
import { urlSliceSelectors } from '../../../redux/url/url.selector';
import { shortenUrlActions } from '../../../redux/url/url.slice';
import { userSliceSelectors } from '../../../redux/user/user.selector';
import { DashboardWidget } from './DashboardWidget';

export const DashboardURLWidget: React.FC = () => {
  const { t } = useTranslation();

  const navigate = useNavigate();
  const dispatch = useAppDispatch();

  const loggedInUserId = useAppSelector(
    userSliceSelectors.selectLoggedInUserId,
  )!;

  const userShortURLs = useAppSelector((s) =>
    urlSliceSelectors.selectShortURLs(s, loggedInUserId),
  );

  const totalVisits = userShortURLs.reduce((acc, url) => acc + url.visits, 0);

  useEffect(() => {
    dispatch(shortenUrlActions.getUserShortURLs({ userId: loggedInUserId }));
  }, [dispatch, loggedInUserId]);

  return (
    <DashboardWidget
      title={t('dashboard.widget.url.title')}
      titleIcon={faLink}
      mainAction={{
        title: t('dashboard.widget.url.action'),
        onClick: () =>
          navigate('/my-urls', { state: { isNavigatedToCreate: true } }),
        icon: faPlusCircle,
      }}
      moreActionLink="/my-urls"
      showActions={Boolean(userShortURLs?.length)}
    >
      {userShortURLs?.length ? (
        <Flex flexDirection="column" gap="m" padding="m">
          <Text>
            <Trans
              i18nKey={'dashboard.widget.url.count'}
              count={userShortURLs.length}
              components={[<strong />]}
            />
          </Text>

          <Text>
            <Trans
              i18nKey={'dashboard.widget.url.visits'}
              count={totalVisits}
              components={[<strong />]}
            />
          </Text>
        </Flex>
      ) : (
        <Flex padding="xl" justifyContent="center" height={'150px'}>
          <AtiraEmptyWithAction
            buttonTitle={t('dashboard.widget.url.action')}
            description={t('dashboard.widget.url.empty.title')}
            onClick={() =>
              navigate('/my-urls', { state: { isNavigatedToCreate: true } })
            }
            buttonWidth="16rem"
          />
        </Flex>
      )}
    </DashboardWidget>
  );
};
